// app-pages/Compliance.tsx
"use client";
import { Box, Heading, Text, VStack, Link, List, ListItem, Flex } from "@chakra-ui/react";
import { Navbar } from "components";
import { Metadata } from 'next';

export const metadata: Metadata = {
  title: {
    default: "",
    template: ""
  },
  description: "Read DeepMode's 18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement. Stay informed about our commitment to legal compliance and user responsibilities."
};

export const Compliance = () => {
  return (
    <Flex direction="column">
      <Navbar />
      <Box mt="50px" mb="100px" px={["25px", "35px", "40px", "60px", "60px", "15%"]}>
        <Heading as="h1" size="xl" mb="4">
          18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement
        </Heading>
        <Text mb="4">
          <strong>Last Updated: October 09, 2024</strong>
        </Text>
        <Text mb="4">
          Please note: DeepMode is an AI content generation platform. This statement outlines our commitment to legal compliance and user responsibilities. We have provided this statement below due to the nature of the topic.
        </Text>
        
        {/* 2257 Compliance Section */}
        <Heading as="h2" size="lg" mt="6" mb="2">
          2257 Compliance
        </Heading>
        <Text mb="4">
          18 U.S.C. Section 2257 Compliance Notice
        </Text>

        <VStack align="start" mb="4">
          <Text>
            <strong>CUSTODIAN OF RECORDS – U.S.C. TITLE 18, SECTION 2257 COMPLIANCE</strong>
          </Text>
          <Text mb="4">
            DeepMode does not produce any content that falls under the requirements of 18 U.S.C. 2257. However, we fully comply with any legal requirements that may pertain to content hosted or generated through our platform. All users are responsible for ensuring that any content they create or upload to DeepMode complies with applicable laws and regulations, including those outlined in 18 U.S.C. 2257.
          </Text>
          <Text mb="4">
            For more details, please review our <Link color="blue.500" href="/terms-and-conditions">Terms and Conditions</Link>.
          </Text>
        </VStack>

        {/* Company Information */}
        <Heading as="h2" size="lg" mt="6" mb="2">
          Company Information
        </Heading>
        <VStack align="start" mb="4">
          <Text>DEEPMODE LTD is registered in Cyprus with the following details:</Text>
          <List spacing={2} mb="4">
            <ListItem>Registration number: HE 464672</ListItem>
            <ListItem>Tax ID: 60094194I</ListItem>
            <ListItem>Registered business address: Spyrou Kyprianou & Agias Phylaxeos (Corner), 182 KOFTEROS BUSINESS CENTER, Office 201, 3083, Limassol, Cyprus</ListItem>
          </List>
        </VStack>

        {/* Contact Section */}
        <Heading as="h2" size="lg" mt="6" mb="2">
          Contact
        </Heading>
        <Text>
          If you have any questions about this Compliance Statement, please contact us at:{" "}
          <Link color="blue.500" href="mailto:info@deepmode.com">
            info@deepmode.com
          </Link>
          .
        </Text>
      </Box>
    </Flex>
  );
};

export default Compliance;
